import React, { useEffect } from 'react';
import { Link } from 'react-router-dom';
import { useLandingBrand } from './useLanding';
import heroBull from '../../assets/landing/hero-bull.webp';
import './landing.css';

/*
 * Full-bleed auth chrome in the v2 (.ftv2) design language. Distraction-free:
 * a brand pitch over the hero image on the left, the form card on the right.
 * Collapses to the card alone < 900px. The actual auth logic lives in the
 * Login / SignUp pages; this only provides the shell.
 */
const POINTS = [
  '90+ intelligence panels in one terminal',
  'Options flow, sentiment, macro and geopolitics',
  'A 1,300+ trader community on the Floor',
];

export default function AuthLayout({ children }) {
  const brand = useLandingBrand();
  const rootStyle = brand.accent
    ? { '--orange': brand.accent, '--orange-dim': brand.accent }
    : undefined;

  useEffect(() => { window.scrollTo(0, 0); }, []);

  return (
    <div className="ftv2" style={rootStyle}>
      <div className="auth">
        <aside className="auth-brand">
          <div className="auth-brand-bg" aria-hidden="true">
            <img src={heroBull} alt="" loading="lazy" decoding="async" />
          </div>
          <Link to="/" className="auth-logo">
            <img src={brand.logo} alt={brand.name} />
            {brand.wordmark}
          </Link>
          <div className="auth-pitch">
            <h2>The terminal the <span className="accent">pros use.</span></h2>
            <div className="auth-points">
              {POINTS.map((p) => <div className="auth-point" key={p}>{p}</div>)}
            </div>
          </div>
          <div className="auth-foot">© 2026 {brand.wordmark} · Built in Bodø, Norway</div>
        </aside>

        <main className="auth-main">
          <div className="auth-card">
            <Link to="/" className="auth-logo auth-mini-logo">
              <img src={brand.logo} alt={brand.name} />
              {brand.wordmark}
            </Link>
            {children}
          </div>
        </main>
      </div>
    </div>
  );
}
